import { get, post, postAttachmentData, postWithDownloadFile, put, remove } from './mainApi';
import { generateId } from 'src/utils/traceIdGenerations';

const timeManagementBaseURL = process.env.REACT_APP_TIME_LOG_ENDPOINT;
const taskManagementURL = timeManagementBaseURL +'task-management/';
const taskAssignmentURL = timeManagementBaseURL +'task-assignment/';
const timeEntryURL = timeManagementBaseURL + 'time-entry';
const projectFav = timeManagementBaseURL + 'favorite-projects';

export const getAllTasks = async (data, offset?, limit?) => {
  try {
    const traceId = generateId(9);
    var response;
    if(limit || offset){
      response = post(`${taskManagementURL}task-summery?traceId=${traceId}&pageSize=${limit}&pageNo=${offset}`, data);
    } else{
      response = post(`${taskManagementURL}task-summery?traceId=${traceId}`, data);
    }
    return response;
  } catch (error) {}
}; 

export const getAllTemplateTasks = async () => {
  try {
    const traceId = generateId(9);
    var response = get(taskManagementURL + 'template-task?traceId=' + traceId);
    return response;
  } catch (error) {}
}; 

export const createTask = async (data) => {
  try {
    const traceId = generateId(9);
    var response = post(taskManagementURL + 'task-save?traceId=' + traceId, {data: data});
    return response;
  } catch (error) {}
}; 

export const updateTask = async (data) => {
  try {
    const traceId = generateId(9);
    var response = put(taskManagementURL + 'task-update?traceId=' + traceId, data);
    return response;
  } catch (error) {}
};

export const deleteTasks = async (data) => {
  try {
    const traceId = generateId(9);
    var response = remove(taskManagementURL + 'task-delete?traceId=' + traceId, data);
    return response;
  } catch (error) {}
};

export const importTasksByExcel = async (data) => {
  const traceId = generateId(9);
  const res = postAttachmentData(
    `${taskManagementURL}upload-task`, 
    {
      ...data,
      traceId: traceId
    }
  );

  return res;
};

export const assignTasks = async (data) => {
  try {
    const traceId = generateId(9);
    var response = post(taskAssignmentURL + 'task-assign?traceId=' + traceId, {data: data});
    return response;
  } catch (error) {}
};

export const getAssignTasks = async (data, offset?, limit?) => {
  try {
    const traceId = generateId(9);
    var response;
    if(limit || offset){
      response = post(`${taskAssignmentURL}assignee-task-summery?traceId=${traceId}&pageSize=${limit}&pageNo=${offset}`, data);
    } else{
      response = post(`${taskAssignmentURL}assignee-task-summery?traceId=${traceId}`, data);
    }
    return response;
  } catch (error) {}
}; 


export const updateAssignedTasks = async (data) => {
  try {
    const traceId = generateId(9);
    var response = put(taskAssignmentURL + 'status-update?traceId=' + traceId, {data: data});
    return response;
  } catch (error) {}
};

export const getTimeEntryData = async (payload) => {
  try {
    const traceId = generateId(9);
    let newUrl;
    newUrl = `${timeEntryURL}?traceId=${traceId}&employeeId=${payload.employeeId}&startDate=${payload.startDate}&endDate=${payload.endDate}`;
    if (payload.filter !== null) {
      newUrl += `&filter=${payload.filter}`;
    }

    const response = get(newUrl);
    return response;
  } catch (error) {}
}; 

export const saveTimeEntryData = async (payload) => {
  try {
    const traceId = generateId(9);
    let response;
    response = post(`${timeEntryURL}?traceId=${traceId}`, payload);
    return response;
  } catch (error) {}
};

export const updateTimeEntryData = async (payload, startDate, endDate) => {
  try {
    const traceId = generateId(9);
    let response;
    response = put(`${timeEntryURL}?traceId=${traceId}&startDate=${startDate}&endDate=${endDate}`, payload);
    return response;
  } catch (error) {}
};

export const requestForRelease = async (data) => {
  try {
    const traceId = generateId(9);
    var response = post(taskAssignmentURL + 'request-for-release?traceId=' + traceId, data);
    return response;
  } catch (error) {}
};

export const getTaskTypes = async () => {
  try {
    const traceId = generateId(9);
    var response = get(taskManagementURL + 'task-type?traceId=' + traceId);
    return response;
  } catch (error) {}
};

export const downloadDetailedReport = async (data) => {
  let newUrl = `${taskManagementURL}detailed-report`;
  const response = postWithDownloadFile(newUrl, data, 'arraybuffer');
  return response;
};

export const getTimeEntryDetailsReport = async (data, offset?, limit?) => {
  try {
    const traceId = generateId(9);
    let response;
    if(limit || offset){
      response = post(`${timeEntryURL}/details-report?traceId=${traceId}&pageSize=${limit}&pageNo=${offset}`, data);
    } else{
      response = post(`${timeEntryURL}/details-report?traceId=${traceId}`, data);
    }
    return response;
  } catch (error) {}
}; 

export const getTimeEntrySummaryReport = async (data, offset?, limit?) => {
  try {
    const traceId = generateId(9);
    let response;
    if(limit || offset){
      response = post(`${timeEntryURL}/summary-report?traceId=${traceId}&pageSize=${limit}&pageNo=${offset}`, data);
    } else{
      response = post(`${timeEntryURL}/summary-report?traceId=${traceId}`, data);
    }
    return response;
  } catch (error) {}
}; 

export const getTimeEntryTaskBasedDetailsReport = async (data, offset?, limit?) => {
  try {
    const traceId = generateId(9);
    let response;
    if(limit || offset){
      response = post(`${timeEntryURL}/taskBased-report?traceId=${traceId}&pageSize=${limit}&pageNo=${offset}`, data);
    } else{
      response = post(`${timeEntryURL}/taskBased-report?traceId=${traceId}`, data);
    }
    return response;
  } catch (error) {}
}; 




export const getAllFavProjects = async () => {
  try {
    const traceId = generateId(9);
    var response = get(projectFav + '?traceId=' + traceId);
    return response;
  } catch (error) {}
}; 

export const setProjectFav = async (data) => {
  try {
    const traceId = generateId(9);
    var response = post(projectFav + '?traceId=' + traceId,data);
    return response;
  } catch (error) {}
}; 

export const updateProjectFav = async (data) => {
  try {
    const traceId = generateId(9);
    var response = put(projectFav + '?traceId=' + traceId,data);
    return response;
  } catch (error) {}
}

export const getVarianceReport = async (data, offset, limit) => {
  try {
    const traceId = generateId(9);
    console.log()
    let response;
    response = post(`${timeEntryURL}/employee-hours-filters?traceId=${traceId}&pageSize=${limit}&pageNo=${offset}`, data);
    return response;
  } catch (error) {
    console.error('Error fetching variance report:', error);
  }
};

export const importTimeEntries = async (data) => {
  const traceId = generateId(9);
  const res = postAttachmentData(
    `${timeEntryURL}/import-time-entries`, 
    {
      ...data,
      traceId: traceId
    }
  );

  return res;
};